import React, { useEffect, useMemo, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import {
  depatmentList,
  employeeList,
} from "../redux/employeeSlice";
import { getRequest } from "../utils/APICall";
import DashboardLoader from "../utils/Loader";
import AttendanceOverview from "../components/Dashboard/AttChart";
import TaskCard from "../components/Dashboard/TaskCard";
import TodayAttTable from "../components/Dashboard/todayAtt";
import DeprtAttChart from "../components/Dashboard/DeprtAtt";
import { useNavigate } from "react-router-dom";


const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [taskData, setTaskData] = useState([]);
  const [EmpData, setEmpData] = useState([]);
  const [todayAttData, setTodayAtt] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const { users } = useSelector((state) => state.user || {});
  const isAuth = users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Admin" || users?.ROLE_TITLE == "Accountant" || users?.ROLE_TITLE == "Supervisor" || users?.ROLE_TITLE == "Manager"
  const departmentColors = {
    "HR": "#00BFFF",
    " IT Enable Services": "#A020F0",
    "Administrator": "#FFBB28",
    "DIGITEL MARKETING": "#FF8042",
    "Desktop Development": "#00C49F",
    "Mobile Development": "#32CD32",
    "Web Development": "#FF4500",
    "Sales": "#075c64",
    "Internship": "#FF6F3C",
    "Accounts": "#EAD196",
  };
  // get all emp data
  const getAllEmp = async () => {
    try {
      const cachedData = sessionStorage.getItem("getAllEmp");
      if (cachedData) {
        try {
          const parsed = JSON.parse(cachedData);
          setEmpData(Array.isArray(parsed) ? parsed : []);
        } catch {
          // Corrupt cache
          sessionStorage.removeItem("getAllEmp");
          setEmpData([]);
        }
      }
      const res = await getRequest("getEmps?employeeType=current");
      // console.log("Employees fetched:", res?.data);
      const data = Array.isArray(res?.data) ? res.data : [];
      setEmpData(data);
      sessionStorage.setItem("getAllEmp", JSON.stringify(data));
    } catch (err) {
      console.error("Failed to fetch employees:", err);
      setEmpData([]);
    }
  };
  // get Today Att
  const getTodayAtt = async () => {
    setPageLoader(true);

    try {
      // 1 Read cache safely
      const cached = sessionStorage.getItem("todayAttData");
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          if (Array.isArray(parsed)) {
            setTodayAtt(parsed);
          } else {
            setTodayAtt([]);
          }
        } catch {
          // Corrupt cache
          sessionStorage.removeItem("todayAttData");
          setTodayAtt([]);
        }
      }

      // 2 API call
      // const endpoint = isAuth
      //   ? "todayAtt"
      //   : "todayAtt?departmentcode=5";
      const endpoint = "todayAtt"

      const response = await getRequest(endpoint);

      // 3 Validate API response
      const data = Array.isArray(response?.data)
        ? response.data
        : [];

      setTodayAtt(data);
      sessionStorage.setItem("todayAttData", JSON.stringify(data));

    } catch (error) {
      console.error("Error fetching today attendance:", error);

      // 4 Fail-safe state
      setTodayAtt([]);
    } finally {
      // 5 Loader ALWAYS stop
      setPageLoader(false);
    }
  };
  function getAttendanceSummary(data) {
    const summary = {
      present: 0,
      absent: 0,
      leave: 0,
      late: 0,
    };

    data.forEach(record => {
      const status = record.ATTENDANCE_STATUS?.toLowerCase();

      if (status === "present") {
        summary.present += 1;
      } else if (status === "absent") {
        summary.absent += 1;
      } else if (record.REMARKS != null) {
        summary.leave += 1;
      }
      else if (status === "late") {
        summary.late += 1;
      }
    });

    return summary;
  }

  const summary = getAttendanceSummary(todayAttData)
  const recruitmentData = useMemo(() => {
    if (!todayAttData || todayAttData.length === 0) return [];
    const deptCount = {};
    todayAttData.forEach((emp) => {
      const dept = emp.TITLE_1 || "Unknown";
      if (!deptCount[dept]) {
        deptCount[dept] = 0;
      }
      deptCount[dept]++;
    });

    return Object.entries(deptCount).map(([dept, count]) => ({
      name: dept,
      value: count,
      color: departmentColors[dept] || "#CCCCCC",
    }));
  }, [todayAttData]);


  const attendanceData2 = [
    { name: "On Time", value: summary?.present, color: "#6be598" },
    { name: "Late Arrivals", value: summary?.late, color: "#edef75" },
    { name: "Absent", value: summary?.absent, color: "#F44336" },
    { name: "Leave", value: summary?.leave, color: "#598bf7" },
  ];
  const fetchAttendance = async () => {
    try {
      const endpoint = "getAllUser"
      // isAuth
      //   ? "getAllUser"
      //   : "getAllUser?departmentcode=5";

      const response = await getRequest(endpoint);

      dispatch(employeeList(
        Array.isArray(response?.data) ? response.data : []
      ));

    } catch (error) {
      console.error("Error fetching attendance:", error);
      dispatch(employeeList([])); //  fail-safe
    }
  };

  // get All Dept
  const getAllDepartment = async () => {
    try {
      const endpoint = isAuth
        ? "getAllDept"
        : "getAllDept?departmentcode=5";

      const response = await getRequest(endpoint);
      // console.log( Array.isArray(response) ? response : [])
      dispatch(depatmentList(
        Array.isArray(response) ? response : []
      ));

    } catch (error) {
      console.error("Error fetching departments:", error);
      dispatch(depatmentList([])); // safe fallback
    }
  };

  // get All Task
  const getAllTask = async () => {
    try {
      // 1 Cache read (safe)
      const cached = sessionStorage.getItem("allTask");
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          setTaskData(Array.isArray(parsed) ? parsed : []);
        } catch {
          sessionStorage.removeItem("allTask");
          setTaskData([]);
        }
      }

      // 2 API call
      const response = await getRequest("getAllTask");

      const data = Array.isArray(response?.data) ? response.data : [];

      // 3 State + cache
      setTaskData(data);
      sessionStorage.setItem("allTask", JSON.stringify(data));

    } catch (error) {
      console.error("Error fetching tasks:", error);
      setTaskData([]); //  fail-safe
    }
  };

  useEffect(()=>{
    if(users.ROLEID == 2 ){
      navigate('/employeetask')
    }
    if(users.ROLEID == 3 ){
      navigate('/todayAttendence')
    }
  },[])
  useEffect(() => {
    if (!users) return;
    getAllTask()
    getAllEmp()
    fetchAttendance();
    getAllDepartment();
    getTodayAtt();
  }, [users]);

  return (
    <div className="flex min-h-screen bg-gray-100 dark:bg-gray-700 dark:text-white">
      {/* <Sidebar  /> */}
      <div className="flex-1  p-4 w-full md:w-auto">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl md:text-4xl font-bold">Dashboard</h1>
        </div>
        {pageLoader ?
          <div className="flex justify-center  items-center w-full min-h-screen">
            <DashboardLoader />
          </div> :
          <>
            {/* top cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4 ">
              <div className="relative bg-white dark:bg-gray-800  p-4 shadow rounded-lg text-center overflow-hidden -z-0">
                <h2 className="text-lg font-semibold z-10 relative">Total Employees</h2>
                <p className="text-3xl font-bold text-blue-600 z-10 relative">
                  {EmpData?.length || 0}
                </p>
                <span className="laser-line1 top-0 left-0 w-full h-0.5 origin-left "></span>
                <span className="laser-line1 top-0 right-0 h-full w-0.5 origin-top [animation-delay:0.5s]"></span>
                <span className="laser-line1 bottom-0 right-0 w-full h-0.5 origin-right [animation-delay:1s]"></span>
                <span className="laser-line1 bottom-0 left-0 h-full w-0.5 origin-bottom [animation-delay:1.5s]"></span>

              </div>
              <div className="relative bg-white dark:bg-gray-800 p-4 shadow rounded-lg text-center overflow-hidden -z-0">
                <h2 className="text-lg font-semibold z-10 relative">Today Presents</h2>
                <p className="text-3xl font-bold text-green-600 z-10 relative">
                  {summary?.present + summary?.late || 0}
                </p>
                <span className="laser-line2 top-0 left-0 w-full h-0.5 origin-left "></span>
                <span className="laser-line2 top-0 right-0 h-full w-0.5 origin-top [animation-delay:0.5s]"></span>
                <span className="laser-line2 bottom-0 right-0 w-full h-0.5 origin-right [animation-delay:1s]"></span>
                <span className="laser-line2 bottom-0 left-0 h-full w-0.5 origin-bottom [animation-delay:1.5s]"></span>
              </div>
              <div className="relative bg-white dark:bg-gray-800 p-4 shadow rounded-lg text-center overflow-hidden -z-0">
                <h2 className="text-lg font-semibold z-10 relative">Today late</h2>
                <p className="text-3xl font-bold text-yellow-600 z-10 relative">
                  {summary?.late || 0}
                </p>
                <span className="laser-line5 top-0 left-0 w-full h-0.5 origin-left "></span>
                <span className="laser-line5 top-0 right-0 h-full w-0.5 origin-top [animation-delay:0.5s]"></span>
                <span className="laser-line5 bottom-0 right-0 w-full h-0.5 origin-right [animation-delay:1s]"></span>
                <span className="laser-line5 bottom-0 left-0 h-full w-0.5 origin-bottom [animation-delay:1.5s]"></span>
              </div>
              <div className="relative bg-white dark:bg-gray-800 p-4 shadow rounded-lg text-center overflow-hidden -z-0">
                <h2 className="text-lg font-semibold z-10 relative">Today Absents</h2>
                <p className="text-3xl font-bold text-red-600 z-10 relative">
                  {summary?.absent || 0}
                </p>
                <span className="laser-line3 top-0 left-0 w-full h-0.5 origin-left "></span>
                <span className="laser-line3 top-0 right-0 h-full w-0.5 origin-top [animation-delay:0.5s]"></span>
                <span className="laser-line3 bottom-0 right-0 w-full h-0.5 origin-right [animation-delay:1s]"></span>
                <span className="laser-line3 bottom-0 left-0 h-full w-0.5 origin-bottom [animation-delay:1.5s]"></span>
              </div>
              <div className="relative bg-white dark:bg-gray-800 p-4 shadow rounded-lg text-center overflow-hidden -z-0">
                <h2 className="text-lg font-semibold z-10 relative">Today Leave</h2>
                <p className="text-3xl font-bold text-blue-600 z-10 relative">
                  {summary?.leave || 0}
                </p>
                <span className="laser-line4 top-0 left-0 w-full h-0.5 origin-left "></span>
                <span className="laser-line4 top-0 right-0 h-full w-0.5 origin-top [animation-delay:0.5s]"></span>
                <span className="laser-line4 bottom-0 right-0 w-full h-0.5 origin-right [animation-delay:1s]"></span>
                <span className="laser-line4 bottom-0 left-0 h-full w-0.5 origin-bottom [animation-delay:1.5s]"></span>
              </div>



            </div>
            {/* top cards */}


            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-white dark:bg-gray-800 p-6 shadow rounded-lg">
                <h2 className="text-xl lg:text-2xl text-center font-bold mb-4">Department Overview</h2>
                <div className="flex items-center">

                  {
                    recruitmentData?.length === 0 ? (
                      <div className="flex justify-center items-center w-full h-60 text-gray-500 italic">
                        No data available
                      </div>
                    ) : (

                      <ResponsiveContainer width={200} height={200}>
                        <PieChart>
                          <Pie
                            data={recruitmentData}
                            dataKey="value"
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={80}
                            paddingAngle={5}
                            startAngle={180}
                            endAngle={-180}
                            label={({ cx, cy }) => (
                              <foreignObject
                                x={cx - 50}
                                y={cy - 10}
                                width={100}
                                height={30}
                              >
                                <div className="text-center text-black dark:text-white font-bold">
                                  Total: {recruitmentData?.length}
                                </div>
                              </foreignObject>
                            )}
                          >
                            {recruitmentData?.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry?.color} />
                            ))}
                          </Pie>
                          <Tooltip formatter={(value, name) => [`${value}`, name]} />
                        </PieChart>
                      </ResponsiveContainer>)}
                  {/* Legend */}
                  <div className="ml-6">
                    {recruitmentData?.map((dept, index) => (
                      <div key={index} className="flex items-center mb-2">
                        <span className="w-4 h-4 mr-2" style={{ backgroundColor: dept?.color }}></span>
                        <span className="text-sm">{dept?.name}</span>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
              <DeprtAttChart attData={todayAttData} />

              <div className="bg-white dark:bg-gray-800 p-4 shadow rounded-lg flex flex-col items-center h-full">
                {<>
                  <AttendanceOverview todayAttData={todayAttData} />
                  <div className="flex space-x-4">
                    {attendanceData2.map((item, index) => (
                      <div key={index} className="flex items-center">
                        <span className="w-4 h-4 rounded-full mr-2" style={{ backgroundColor: item.color }}></span>
                        <span className="text-sm">{item.name} ({item.value})</span>
                      </div>
                    ))}
                  </div>
                </>}
              </div>
            </div>
            <div className=" mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-4">
              <TodayAttTable todayAttData={todayAttData} />
              <TaskCard taskData={taskData} />
            </div> </>}

      </div>
    </div>
  );
};

export default Dashboard;
